(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '../../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('../../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.colors);
    global.StatusIcon = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    font-size: 18px;\n  '], ['\n    font-size: 18px;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n      color: ', ';\n    '], ['\n      color: ', ';\n    ']);

  var dragon = _colors2.default.dragon,
      prussian = _colors2.default.prussian,
      gold = _colors2.default.gold;


  var styles = {
    statusIcon: (0, _reactEmotion.css)(_templateObject)
  };

  var statusMappings = {
    loading: {
      iconName: '',
      color: ''
    },
    success: {
      iconName: 'done',
      color: (0, _reactEmotion.css)(_templateObject2, prussian)
    },
    warn: {
      iconName: 'done',
      color: (0, _reactEmotion.css)(_templateObject2, gold)
    },
    error: {
      iconName: 'clear',
      color: (0, _reactEmotion.css)(_templateObject2, dragon)
    }
  };

  var StatusIcon = function StatusIcon(_ref) {
    var status = _ref.status;
    return _react2.default.createElement(
      'div',
      { className: 'layout-column layout-align-center' },
      _react2.default.createElement(
        'span',
        {
          className: 'material-icons ' + (0, _reactEmotion.cx)(styles.statusIcon, statusMappings[status].color)
        },
        statusMappings[status].iconName
      )
    );
  };

  exports.default = StatusIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/components/StatusIcon.js
// module id = 2039
// module chunks = 1